import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { AdmissionsAcceleratorsService } from '../admissions-accelerators.service';
import { AdmissionsAcceleratorsAcceleratorSeatsViewPart } from './accelerator-seats/accelerator-seats.part';
import { AdmissionsAcceleratorsViewPart } from './accelerators/accelerators-view.part';
import { AdmissionsTeamsViewPart } from './teams/teams-view.part';

@Component({
	selector: 'admissions-accelerators-views-part',
	standalone: true,
	imports: [
		AdmissionsAcceleratorsViewPart,
		AdmissionsTeamsViewPart,
		AdmissionsAcceleratorsAcceleratorSeatsViewPart,
		DroplistWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './accelerators-views.part.html',
})
export class AdmissionsAcceleratorsViewsPart implements OnInit {

	public service = inject(AdmissionsAcceleratorsService);

	ngOnInit() {
		this.service.initializeUrl();
	}

}
